import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import {Router} from '@angular/router';

@Component({
  selector: 'app-mainbrowse-tsic',
  templateUrl: './mainbrowse-tsic.component.html',
  styleUrls: ['./mainbrowse-tsic.component.css']
})
export class MainbrowseTsicComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    $(document).ready(() => {
      $.getScript('../assets/js/custom.js');

      $.getScript('../assets/js/scripts/searchByCategory.js');
      // console.log('load searchByCategory success !!');
      $.getScript('../assets/js/scripts/paging.js');
      // console.log('load paging success !!');
      $.getScript('../assets/js/scripts/suggessionWord.js');
      // console.log('load suggessionWord success !!');
      

    });
  }

  public searchData(value: string){
    this.router.navigate(['../searchResult'], {queryParams: {textSearch: value, selectType: 0} }).then(() => window.location.reload());
  }

  public searchByCategory(value: string){
    this.router.navigate(['../brows_tsic'], {queryParams: {category: value} });
    $.getScript('../assets/js/scripts/searchByCategory.js');
  }
}
